<div>
  <div [class.d-none]="!params.state.visible">
    <div class="modal-backdrop fade show"></div>
    <div role="dialog" tabindex="-1" class="modal fade show d-block">
      <div role="document" class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 i18n class="m-auto h4 modal-title">Upload</h4>
            <button
              *ngIf="areAllUploadsFinished"
              type="button"
              class="close"
              aria-label="Close"
              (click)="closeOrMinimize()"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <button
              *ngIf="!areAllUploadsFinished"
              type="button"
              class="close"
              aria-label="Minimize"
              (click)="closeOrMinimize()"
            >
              <span aria-hidden="true">&mdash;</span>
            </button>
          </div>
          <div class="modal-body form">
            <div class="form-group">
              <span i18n class="text-muted"> Select files from your computer </span>
              <button class="float-right btn btn-success upload-btn" #chooseFiles i18n>Choose files</button>
              <span class="clearfix"></span>
            </div>
            <div class="form-group">
              <div #droppableArea class="dropzone" [ngClass]="['dropzone-' + uniqueIdentifier]">
                <div class="dz-message placeholder">
                  <i class="mb-3 fa fa-plus fa-fw fa-2x" aria-hidden="true"></i>
                  <div i18n>Drag'n drop files here to upload</div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <div class="text-muted" i18n>Accepted file types: {{ validTypes }}</div>
            </div>

            <div class="form-group">
              <div class="text-muted" i18n>Individual file size limit: {{ params.maxFileSize }}MB</div>
            </div>

            <div class="text-center form-group">
              <button
                [disabled]="!areAllUploadsFinished"
                class="upload-done-btn btn btn-primary"
                i18n
                (click)="closeOrMinimize()"
              >
                Done
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="p-3 upload-sprite sm-cursor-pointer" *ngIf="params.state.minimized" (click)="showModal()">
    <div class="">
      <div i18n *ngIf="!areAllUploadsFinished" class="rounded message-box bg-warning">
        <i class="cc-icon cc-icon-spinner-fw"></i
        ><span>Uploading {{ params.state.uploaded }}/{{ params.state.total }} </span>
      </div>

      <div i18n class="rounded message-box bg-success" *ngIf="areAllUploadsFinished">
        <i class="fa fa-check fa-fw"></i><span>Upload is finished.</span>
      </div>
    </div>
  </div>
</div>
